import { Home } from "@/components/Home";
import React from "react";

const HomePage: React.FC = () => {
  return <Home />;
};
export default HomePage;
